jQuery(document).ready(function ($) {

    // BLOG
    // Envía el formulario de filtrado del blog al cambiar los selectores de año o categoría
    $('#year-select, #category-select').on('change', function () {
        $('#blog-filter-form').submit();
    });

    // OCASIÓN
    // Actualiza el título de filtro con la opción seleccionada al cargar la página y al cambiar la selección en los selectores
    if ($('#ocasion').length > 0) {
        $('select').each(function () {
            var selectedOption = $(this).find('option:selected').text();
            $(this).prev('.filter-title').text(selectedOption);
        });

        $('select').change(function () {
            var selectedOption = $(this).find('option:selected').text();
            $(this).prev('.filter-title').text(selectedOption);
            $(this).closest('form').submit();
        });
    }

    // VACANTES
    // Auto scroll al recargar la página tras añadir un filtro
    if ($('.post-type-archive-vacancy').length > 0) {
        
        let isFiltered = /[?&]/.test(location.search);

        let offset = 40;
        let scrollHeight = $(window).height() - offset;


        if (isFiltered == true) {
            
                $("body,html").animate({scrollTop: scrollHeight}, 300);
            
        }

    
    }
});

